export const SET_TEMPLATES = (state, payload) => {
  state.templates = payload;
}

export const SET_TEMPLATE = (state, payload) => {
  state.template = payload;
}

export const SET_RESULT = (state, payload) => {
  state.resultBoxes = payload.boxes;
}

export const SET_ITEMS = (state, payload) => {
  state.items = payload;
}

export const DATA_QUERY = (state, payload) => {
  state.querys = payload;
}

export const SET_BATCHES = (state, payload) => {
  state.batches = payload;
}

export const SET_BATCH = (state, payload) => {
  state.batch = payload;
}

export const LOGOUT_TEMPLATE = (state) => {
  const dataTemplate = {
    boxes: [],
    collection_id:1,
    ground_truth_image:null,
    id:0,
    is_assignment:false,
    is_instant:false,
    is_preprocess:false,
    name:"",
    type:0,
    url: ''
  }
  state.template = {...dataTemplate};
}


